import { render, staticRenderFns } from "./ratelCkeditor.vue?vue&type=template&id=59b65f00&scoped=true"
import script from "./ratelCkeditor.vue?vue&type=script&lang=js"
export * from "./ratelCkeditor.vue?vue&type=script&lang=js"
import style0 from "./ratelCkeditor.vue?vue&type=style&index=0&id=59b65f00&prod&lang=less&scoped=true"
import style1 from "./ratelCkeditor.vue?vue&type=style&index=1&id=59b65f00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b65f00",
  null
  
)

export default component.exports